<template>
  <div>
    <baseFrame clearText='' submitText='提交' :submitLoading='submitLoading' @submit='submit'>
      <div slot="content">
        <lk-card title="开票信息">
          <lk-form :label-width='120' label-position='right' :model='info' :rules='validate' ref="form">
            <lk-row :gutter='16'>
              <lk-col span='7'>
                <lk-form-item label='开票时间:'>
                  <timeStampDatePicker v-model="info.invoiceCreateTime" placeholder=" 请选择" class="item"  :disabled='!able' :clearable="false"></timeStampDatePicker>
                </lk-form-item>
              </lk-col>
              <lk-col span='7' offset='1'>
                <lk-form-item label='发票类型:' prop='invoiceType' >
               <lk-select v-model='info.invoiceType'  :disabled='!able' placeholder="请选择">
                <lk-option v-for="(item,i) in invoiceTypeList" :key="i" :value='i*1'>{{item}}</lk-option>
              </lk-select>
                  </lk-form-item>
              </lk-col>
              <lk-col span='7' offset='1'>
                <lk-form-item label='发票编码:' prop='invoiceCode'>
                  <lk-input v-model="info.invoiceCode" :maxlength='100' placeholder='请输入，多个发票号以“，”隔开' class="item"  :disabled='!able'></lk-input>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span='7' >
                <lk-form-item label='患者姓名:'>
                  <lk-input v-model="info.patientName" :maxlength='100' placeholder='请输入' class="item"  :disabled='!able'></lk-input>
                </lk-form-item>
              </lk-col>
              <lk-col span='7' offset='1'>
                <lk-form-item label='发票图片:'>
                  <Uploader v-model='info.invoiceImgUrl' :able='able'  :format="['jpg', 'jpeg', 'pdf', 'png']"></Uploader>
               </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row>
              <lk-col span='23'>
                <lk-form-item label='发票明细:'>
                  <div class="mb12" v-if="able">
                    <lk-button type='primary' @click="addOrder">+新增</lk-button>
                    <!-- <lk-button v-else type='primary' style="visibility: hidden" >新增</lk-button> -->
                  </div>
                  <lk-table :columns='columns' border :data='info.orderList'></lk-table>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16' >
              <lk-col span='7' >
                <lk-form-item label='发票总金额:'>
                  <DtpInputNumber :precision="2" :disabled="!able" v-model="info.totalAmount" placeholder="请输入" style="width: 100%;"></DtpInputNumber>
                  <!-- <lk-input v-model="info.totalAmount" :maxlength='100' placeholder='请输入' class="item" clearable :disabled='!able'></lk-input> -->
                </lk-form-item>
              </lk-col>
              <lk-col span='7' offset='1'>
                <lk-form-item label='商品总金额:'>
                  <span>{{ goodsTotalAmount }}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span='7' >
                <lk-form-item label='发票不含税总金额:'>
                  <!-- <lk-input v-model="info.totalAmountWithoutTax" :maxlength='100' placeholder='请输入' class="item" clearable :disabled='!able'></lk-input> -->
                  <DtpInputNumber :precision="2" :disabled="!able" v-model="info.totalAmountWithoutTax" placeholder="请输入" style="width: 100%;"></DtpInputNumber>
                </lk-form-item>
              </lk-col>
              <lk-col span='7' offset='1'>
                <lk-form-item label='商品不含税总金额:'>
                  <span>{{ goodsTotalAmountWithoutTax }}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span='7' >
                <lk-form-item label='发票税额:'>
                  <DtpInputNumber :precision="2" :disabled="!able" v-model="info.taxAmount" placeholder="请输入" style="width: 100%;"></DtpInputNumber>
                  <!-- <lk-input v-model="info.taxAmount" :maxlength='100' placeholder='请输入' class="item" clearable :disabled='!able'></lk-input> -->
                </lk-form-item>
              </lk-col>
              <lk-col span='7' offset='1'>
                <lk-form-item label='商品税额:'>
                  <span>{{ goodsTaxAmount }}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-form>
        </lk-card>
      </div>
    </baseFrame>
    <lk-modal title="选择单据" v-model="orderModal" :width='900'>
      <div class="modalContent">
        <div class="modalQuery mb16">
          <div class="queryItem">
            <label>订单类型:</label>
            <lk-select class="item" v-model.trim='orderType'>
              <lk-option v-for="(item,index) in orderTypeList" :key="index" :value='index'>{{item}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>商品名称:</label>
            <lk-input :maxlength='100' placeholder='支持商品编码、通用名、商品名' class="item" clearable
              v-model.trim='query.nameMix'></lk-input>
          </div>
          <div class="queryItem">
            <label>单据日期:</label>
            <timeStampDatePicker  type='daterange' placeholder="请选择" class="item" v-model.trim='query.orderTimeRange'  clearable style="width: 200px;"></timeStampDatePicker>
          </div>
          <div>
            <lk-button type='primary' @click="getOrderList()">搜索</lk-button>
          </div>
        </div>
        <div slot="table" >
          <lk-table border :columns='selectOrderColumns' @on-selection-change='handleOrderSelect' :data='orderSearchList' ></lk-table>
          <div style="text-align:right;padding-top:15px;">
            <lk-page :total="orderCount" size="small" show-total show-sizer show-elevator @on-change='handlePage' @on-page-size-change='handleSize'></lk-page>
          </div>
        </div>
      </div>
      <div slot="footer">
        <span class="mr8">{{ '已选：'+selectedOrders.length+'项' }}</span>
        <lk-button @click='cancleAddOrder'>取消</lk-button>
        <lk-button type='primary' @click="addOrderConfirm">确定</lk-button>
      </div>
    </lk-modal>
  </div>
</template>
<script>
import baseFrame from '../../components/frame/BaseFrame.vue';
import utils from '../../libs/utils';
import finance from '../../services/finance';
import DtpInputNumber from '../../components/DtpInputNumber';
import Uploader from '../../components/Uploader.vue';

export default {
  name: 'invoiceInfo',
  components: { baseFrame, DtpInputNumber, Uploader },
  watch: {
    'info.orderList': {
      handler(val) {
        if (val.length && val[val.length - 1].patientName) {
          this.info.patientName = val[val.length - 1].patientName;
        }
      },
    },
  },
  computed: {
    selectedCodeIDs() {
      const result = [];
      this.info.orderList.forEach((item) => {
        result.push(item.financeInvoiceDetailInvoiceInfoKey);
      });
      return result;
    },
    goodsTotalAmount() {
      let sum = 0;
      this.info.orderList.forEach((item) => {
        sum += item.financeInvoiceDetailAmount;
      });
      return sum.toFixed(2) * 1;
    },
    goodsTotalAmountWithoutTax() {
      let sum = 0;
      this.info.orderList.forEach((item) => {
        sum += item.financeInvoiceDetailAmountWithoutTax;
      });
      return sum.toFixed(2) * 1;
    },
    goodsTaxAmount() {
      let sum = 0;
      this.info.orderList.forEach((item) => {
        sum += item.financeInvoiceDetailTotalTax;
      });
      return sum.toFixed(2) * 1;
    },
  },
  data() {
    return {
      invoiceTypeList: {
        1: '增值税普通发票',
        2: '增值税电子发票',
      },
      orderType: 0,
      orderTypeList: ['销售订单', '退货单'],
      able: true,
      orderModal: false,
      submitLoading: false,
      query: {
        invoiceId: null,
        nameMix: '',
        orderTimeRange: [],
      },
      info: {
        id: null,
        orderList: [], // 明细ID
        invoiceCreateTime: new Date().getTime(), // 开票时间
        invoiceCode: '', // 发票编码
        totalAmount: null, // 发票总金额
        totalAmountWithoutTax: null, // 发票不含税金额
        taxAmount: null, // 税额
        invoiceImgUrl: '',
      },
      validate: {
        invoiceCode: [
          { required: true, message: '请填写发票编码', trigger: 'blur' },
        ],
        invoiceType: [
          {
            required: true, message: '请选择发票类型', trigger: 'blur', type: 'number',
          },
        ],
      },
      columns: [
        {
          type: 'expand',
          width: 50,
          render: (h, params) => h('div', [
            h('span', { style: { marginRight: '15px' } }, `批准文号:${params.row.goodsInfoVoApprovalCode}`),
            h('span', { style: { marginRight: '15px' } }, `生产厂家:${params.row.goodsInfoVoProducer}`),
            h('span', { style: { marginRight: '15px' } }, `剂型:${params.row.goodsInfoVoDosageFormName}`),
            h('span', { style: { marginRight: '15px' } }, `供应商:${params.row.financeInvoiceDetailSupplierName}`),
          ]),
        },
        { title: '业务单据号', key: 'financeInvoiceDetailReferCode', minWidth: 150 },
        { title: '患者姓名', key: 'patientName', minWidth: 136 },
        { title: '商品名称', key: 'goodsInfoVoApprovedDrugName', minWidth: 116 },
        { title: '规格', key: 'goodsInfoVoSpec', minWidth: 116 },
        { title: '包装单位', key: 'goodsInfoVoDrugMiniPackageUnitString', minWidth: 116 },
        { title: '销售单价', key: 'financeInvoiceDetailPrice', minWidth: 116 },
        { title: '数量', key: 'financeInvoiceDetailNum', minWidth: 116 },
        { title: '含税金额', key: 'financeInvoiceDetailAmount', minWidth: 116 },
        { title: '税率', key: 'financeInvoiceDetailOutputTaxRate', minWidth: 116 },
        { title: '不含税金额', key: 'financeInvoiceDetailAmountWithoutTax', minWidth: 116 },
        { title: '税额', key: 'financeInvoiceDetailTotalTax', minWidth: 116 },
        {
          title: '操作',
          minWidth: 116,
          render: (h, params) => h('lk-button', {
            props: {
              type: 'text',
              size: 'small',
              disabled: !this.able,
            },
            on: {
              click: () => {
                this.info.orderList.splice(params.index, 1);
                this.handlePageChange();
              },
            },
          }, '删除'),
        },
      ],
      selectOrderColumns: [
        { type: 'selection', width: 52 },
        { title: '业务单据号', key: 'financeInvoiceDetailReferCode', minWidth: 116 },
        { title: '患者姓名', key: 'patientName', minWidth: 136 },
        { title: '商品名称', key: 'goodsInfoVoApprovedDrugName', minWidth: 116 },
        { title: '规格', key: 'goodsInfoVoSpec', minWidth: 130 },
        { title: '包装单位', key: 'goodsInfoVoDrugMiniPackageUnitString', minWidth: 116 },
        { title: '销售单价', key: 'financeInvoiceDetailPrice', minWidth: 116 },
        { title: '数量', key: 'financeInvoiceDetailNum', minWidth: 136 },
        { title: '含税金额', key: 'financeInvoiceDetailAmount', minWidth: 116 },
        { title: '税率', key: 'financeInvoiceDetailOutputTaxRate', minWidth: 116 },
        { title: '不含税金额', key: 'financeInvoiceDetailAmountWithoutTax', minWidth: 116 },
        { title: '税额', key: 'financeInvoiceDetailTotalTax', minWidth: 136 },
      ],
      orderSearchList: [], // 查询结果
      selectedOrders: [], // 选择结果
      orderPage: 1, // 新增明细 查询page
      orderSize: 10, // 新增明细 查询size
      orderCount: 0, // 新增明细 count
    };
  },
  methods: {
    // 及时更新输入框中的数值
    // TODO 在新增确定时、列表项删除时、都需要添加此方法。
    handlePageChange() {
      this.$nextTick(() => {
        this.info.totalAmount = this.goodsTotalAmount;
        this.info.totalAmountWithoutTax = this.goodsTotalAmountWithoutTax;
        this.info.taxAmount = this.goodsTaxAmount;
      });
    },
    cancleAddOrder() {
      this.orderModal = false;
    },
    addOrderConfirm() {
      this.selectedOrders.forEach((item) => {
        if (!this.selectedCodeIDs.includes(item.financeInvoiceDetailInvoiceInfoKey)) {
          this.info.orderList.push(item);
        }
      });
      this.orderModal = false;
      this.handlePageChange();
    },
    add(submitParams) {
      finance.addInvoice(submitParams).then((res) => {
        if (res.data.status === 200) {
          console.log(res);
          this.$router.push({ name: 'invoice' });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        this.submitLoading = false;
        utils.handleError(err);
      });
    },
    edit(submitParams) {
      finance.editInvoice(submitParams).then((res) => {
        if (res.data.status === 200) {
          console.log(res);
          this.$router.push({ name: 'invoice' });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        this.submitLoading = false;
        utils.handleError(err);
      });
    },
    submit() {
      const params = utils.deepClone(this.info);
      // if (params.invoiceCode == null || params.invoiceCode == '') {
      //   this.$Message.error('请填写发票编码');
      //   return;
      // }
      this.$refs.form.validate((valid) => {
        if (valid) {
          const submitParams = {
            financeInvoice: {
              id: params.id,
              amount: params.totalAmount ? params.totalAmount : 0,
              amountWithoutTax: params.totalAmountWithoutTax ? params.totalAmountWithoutTax : 0,
              tax: params.taxAmount ? params.taxAmount : 0,
              invoiceDate: params.invoiceCreateTime, // .getTime(),
              code: params.invoiceCode,
              patientName: params.patientName,
              invoiceImgUrl: params.invoiceImgUrl,
              invoiceType: params.invoiceType,
            },
            financeInvoiceDetailVoList: [],
          };
          params.orderList.forEach((item) => {
            const elem = {
              financeInvoiceDetail: {
                referDetailId: item.financeInvoiceDetailReferDetailId,
                referType: item.referType,
                goodsStoreId: item.financeInvoiceDetailGoodsStoreId,
              },
            };
            submitParams.financeInvoiceDetailVoList.push(elem);
          });
          console.log(submitParams);
          if (this.$route.name === 'invoiceEdit') {
            this.edit(submitParams);
          } else {
            this.add(submitParams);
          }
        }
      });
    },
    getData() {
      console.log(this);
      finance.getInvoiceInfo({ financeInvoiceId: this.$route.params.id }).then((res) => {
        if (res.data.status === 200) {
          const { financeInvoice, financeInvoiceDetailVoList } = res.data.data;
          this.query.invoiceId = financeInvoice.id;
          this.info = {// 这里有点坑
            id: financeInvoice.id,
            invoiceCreateTime: financeInvoice.invoiceDate,
            invoiceCode: financeInvoice.code,
            totalAmount: financeInvoice.amount,
            totalAmountWithoutTax: financeInvoice.amountWithoutTax,
            taxAmount: financeInvoice.tax,
            patientName: financeInvoice.patientName,
            invoiceType: financeInvoice.invoiceType,
            invoiceImgUrl: financeInvoice.invoiceImgUrl || '',

            orderList: [],
          };
          if (financeInvoiceDetailVoList) {
            financeInvoiceDetailVoList.forEach((detail) => {
              const result = {};
              utils.exchangeTable(detail, result);

              result.referType = result.financeInvoiceDetailReferType;
              if (!result.goodsInfoVoDosageFormName) {
                result.goodsInfoVoDosageFormName = '';
              }
              this.info.orderList.push(result);
              this.selectedCodeIDs.push(result.financeInvoiceDetailInvoiceInfoKey);
            });
          }
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    addOrder() {
      this.orderModal = true;
      this.getOrderList();
    },
    getOrderList() {
      const params = utils.deepClone(this.query);
      if (params.orderTimeRange && params.orderTimeRange[1]) {
        params.createTimeStart = new Date(new Date(params.orderTimeRange[0]).toLocaleDateString()).getTime();
        params.createTimeEnd = (new Date(params.orderTimeRange[1])).getTime();
      }
      params.page = this.orderPage;
      params.size = this.orderSize;
      if (this.orderType === 0) {
        finance.getOrderToInvoiceList(params).then((res) => {
          if (res.data.status === 200) {
            this.orderSearchList = [];
            res.data.data.list.forEach((item) => {
              const resultItem = {};
              utils.exchangeTable(item, resultItem);
              resultItem.referType = 1;
              if (this.selectedCodeIDs.includes(resultItem.financeInvoiceDetailInvoiceInfoKey)) {
                resultItem._checked = true;
                resultItem._disabled = true;
              }
              if (!resultItem.goodsInfoVoDosageFormName) {
                resultItem.goodsInfoVoDosageFormName = '';
              }
              this.orderSearchList.push(resultItem);
            });
            this.orderCount = res.data.data.count;
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      } else {
        finance.getRefundToInvoiceList(params).then((res) => {
          if (res.data.status === 200) {
            this.orderSearchList = [];
            res.data.data.list.forEach((elem) => {
              const resultElem = {};
              utils.exchangeTable(elem, resultElem);
              resultElem.referType = 2;
              if (this.selectedCodeIDs.includes(resultElem.financeInvoiceDetailInvoiceInfoKey)) {
                resultElem._checked = true;
                resultElem._disabled = true;
              }
              if (!resultElem.goodsInfoVoDosageFormName) {
                resultElem.goodsInfoVoDosageFormName = '';
              }
              this.orderSearchList.push(resultElem);
            });
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      }
    },
    handleOrderSelect(val) {
      this.selectedOrders = [];
      console.log(val);
      val.forEach((item) => {
        this.selectedOrders.push(item);
      });
    },
    handlePage(val) {
      this.orderPage = val;
      this.getOrderList();
    },
    handleSize(val) {
      this.orderSize = val;
      this.getOrderList();
    },
  },
  created() {
    if (this.$route.name === 'invoiceCheck') {
      this.able = false;
    }
    if (this.$route.name != 'invoiceAdd') {
      this.getData();
    }
  },
};

</script>
<style lang="less" scoped>
.modalContent {
  .modalQuery {
    display: flex;
    .queryItem {
      margin-right: 16px;
      display: flex;
      align-items: center;
      width: 320px;

      label {
        width: 65px
      }

    }
  }
}
// .ml{
//   margin-left: 105px;
// }
.mb12{
  margin-bottom: 12px;
}
</style>
